export default __webpack_public_path__ + "static/media/rnd-card.ed6159f7.png";